import * as yup from "yup";

export const TimeSheetCategoryTrackingSetupValidationSchema = yup.object().shape({

});
